import { useEffect } from "react";
import { useParams } from "react-router-dom";
import useUserIdentity from "hooks/useUserIdentity";
import Stack from "@mui/joy/Stack";

import useFile from "hooks/useFile";

export default function FilesRedirectDownload() {
    const { currentIdentity }  = useUserIdentity();

    const { association_uuid } = useParams<{association_uuid: string}>();
    const { getDownloadUrl } = useFile();

    useEffect(() => {
        if(!currentIdentity) {
            console.error("No identity");
            return;
        }
        if(!association_uuid) {
            console.error("No association_uuid");
            return;
        }
         getDownloadUrl(currentIdentity?.key, association_uuid, "attachment").
            then((url: string | null) => {
                if(url) {
                    window.location.href = url;
                }
                else {
                    Error("Unable to get download url");
                }
            });
    }, [currentIdentity, association_uuid, getDownloadUrl]);

    return (<Stack
            width={"100%"}
            height={"70%"}
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2}
    >Downloading file...</Stack>
    );

}
